import { useRef, useState, useEffect, useContext } from 'react';
import AuthContext from "./context/AuthProvider"
import { loadDatabases } from './../database/databaseLoader'
import axios from './api/axios';
import { useNavigate } from 'react-router-dom';
import { GetUserSettings } from "../database/userInfo";
import { useSettings } from "../Navbar/settingsContext"
import './register.css'

const LOGIN_URL = '/auth';


const Login = (props) => {
  const navigate = useNavigate();
const { setUserSettings } = useSettings();
  const { setAuth } = useContext(AuthContext);
  const userRef = useRef();
  const errRef = useRef();

  const [user, setUser] = useState('');
  const [pwd, setPwd] = useState('');
  const [errMsg, setErrMsg] = useState('');
  const [success, setSuccess] = useState(false);
  const [token, setToken] = useState(localStorage.getItem("site") || "");

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  async function Ldb() {
    loadDatabases().then((data) => {
      setLoading(false)
      setSuccess(true);
    });
  }
  async function readUserSettings() {
    const getSettings = async () => {
      const data = await GetUserSettings();
      
      const d2 = data.success
      const settings = {
        id: d2.id,
        user_id: d2.user_id,
        pakket: d2.pakket,
        onlysa: d2.onlysa,
        standardUitvoering: d2.standardUitvoering,
        maxadres: d2.maxadres,
      }
      setUserSettings(settings);
    };



    getSettings();
  };


  useEffect(() => {
    userRef.current.focus();
  }, []);

  useEffect(() => {
    setErrMsg('');
  }, [user, pwd]);


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send Login request to server with Username / Password
      const response = await axios.post(
        LOGIN_URL,
        JSON.stringify({ user, pwd }),
        {
          headers: { 'Content-Type': 'application/json' },
          withCredentials: true,
        }
      );


      const accessToken = response?.data?.accessToken;
      const id = response?.data?.userid;
      const r = response?.data?.r;
      const responseLanguage = (response?.data?.language || "").toUpperCase();
      const language = ["NL", "FR", "EN"].includes(responseLanguage)
        ? responseLanguage
        : "NL";

      setAuth({ user, pwd, r, accessToken, language });

      setToken(accessToken);

      sessionStorage.setItem("accessToken", accessToken);
      sessionStorage.setItem("language", language);

      setUser('');
      setPwd('');



      { props.onSetToken(user, r, accessToken, id, language) }

      setLoading(true);
      
      await Ldb();
      await readUserSettings();

    } catch (err) {
      if (!err?.response) {
        setErrMsg('No Server Response');
      } else if (err.response?.status === 400) {
        setErrMsg('Missing Username or Password');
      } else if (err.response?.status === 401) {
        setErrMsg('Unauthorized');
      } else {
        setErrMsg('Login Failed');
      }
      errRef.current.focus();
    }
  };

  return (

    <div className="textColor">
      {loading ? (
        <div className="loader-container">
          <div className="spinner">Even geduld aub, we laden de gegevens uit de database.</div>
        </div>
      ) : (<></>)}

      {success ? (

        navigate('/')
      ) : (
        <section>
          <p
            ref={errRef}
            className={errMsg ? "errmsg" : "offscreen"}
            aria-live="assertive"
          >
            {errMsg}
          </p>
          <h1>Aanmelden</h1>
          <form onSubmit={handleSubmit}>
            <label htmlFor="username">Gebruikersnaam:</label>
            <input
              type="text"
              id="username"
              ref={userRef}
              autoComplete="off"
              onChange={(e) => setUser(e.target.value)}
              value={user}
              required
            />
            <label htmlFor="password">Wachtwoord:</label>
            <input
              type="password"
              id="password"
              onChange={(e) => setPwd(e.target.value)}
              value={pwd}
              required
            />
            <br></br>
            <button className='colorButton'>Aanmelden</button>
          </form>
          <p>
            Een account nodig?
            <br />
            <span className="line">
              <a href="/register">Registreer</a>
            </span>
          </p>
        </section>
      )}
    </div>
  );
};

export default Login;
/*
export const useAuth = () => {
  return useContext(AuthContext);
};
*/